import { z } from 'zod';
import { Binding, ControlSide, ControlType, HidePanel, Separation, SystemType } from '../enums';

// Толерантная схема входного `Item` (реальная схема конфигуратора,
// docs/plan/discovery-rollo.md §11):
// - числа могут приходить строкой ("6.80") → коэрсим;
// - множество nullable-полей; лишние коммерческие поля игнорируются (zod strip);
// - контракт сохраняется 1:1 (D7), единицы — см (railSize — мм).

const num = z.coerce.number();
const str = z.string();

export const SectionSchema = z.object({
  width: num,
  height: num,
  materialColor: str.nullable().optional(),
  perforationType: str.nullable().optional(),
  perforationCount: num.nullable().optional(),
});
export type Section = z.infer<typeof SectionSchema>;

export const LayerSchema = z.object({
  width: num,
  height: num,
  railColor: str.nullable().optional(),
  railSize: num.optional(),
  chainColor: str.nullable().optional(),
  controlType: ControlType,
  controlSide: ControlSide.nullable().optional(),
  controlAccType: str.nullable().optional(),
  remoteControl: z.unknown().nullable().optional(),
  sections: z.array(SectionSchema).min(1),
});
export type Layer = z.infer<typeof LayerSchema>;

export const PartSchema = z.object({
  width: num,
  height: num,
  mountPoints: num.optional(),
  cpColor: str.nullable().optional(),
  layers: z.array(LayerSchema).min(1),
});
export type Part = z.infer<typeof PartSchema>;

export const ItemSchema = z.object({
  model: SystemType,
  width: num,
  height: num,
  binding: Binding.optional(),
  bindingTop: num.optional(),
  bindingHeight: num.optional(),
  hidePanel: HidePanel.nullable().optional(),
  ptColor: str.nullable().optional(),
  pcFixedColor: str.nullable().optional(),
  collection: str.optional(),
  sectionSize: num.optional(),
  railSize: num.optional(),
  separation: Separation.optional(),
  dpWidth: num.optional(),
  dpCount: num.optional(),
  parts: z.array(PartSchema).min(1),
});
export type Item = z.infer<typeof ItemSchema>;

/** Разобрать и провалидировать вход; бросает ZodError при ошибке. */
export function parseItem(input: unknown): Item {
  return ItemSchema.parse(input);
}

/** Безопасный разбор: { success, data | error }. */
export function safeParseItem(input: unknown) {
  return ItemSchema.safeParse(input);
}
